import { MenuItem, Text } from "@chakra-ui/react"
import { useRouter } from "next/router"
import PropTypes from "prop-types"
import { fileTypes } from "../../../../../../common/constants/constants"
import { getArchivedArticleDownloadZipUrl, getArticleDownloadZipUrl } from "../../../../../../common/hooks/queries"
import { useBrandedTranslation } from "../../../../../../common/hooks/useBrandedTranslation"
import { useDownloadFile } from "../../../../../../common/hooks/useDownloadFile"
import LoadingIcon from "../../../../../shared/DownloadButton/LoadingIcon"
import { CProductImages } from "../../../../../shared/Icons"

const DownloadImagesMenuItem = ({ zipPhotosDrawingsLink, isArchived }) => {
  const { t } = useBrandedTranslation()
  const { locale, query } = useRouter()
  const brand = String(query.brand)
  const getArticleDownloadZip = isArchived ? getArchivedArticleDownloadZipUrl : getArticleDownloadZipUrl
  const { onClickDownloadFile: onClickDownloadZip, isFileLoading: isZipFileDownloading } = useDownloadFile(
    zipPhotosDrawingsLink,
    brand,
    locale,
    fileTypes.ZIP,
    getArticleDownloadZip,
    "PHOTOS_DRAWINGS",
    `PhotoAndDrawings_${zipPhotosDrawingsLink}`
  )

  if (!zipPhotosDrawingsLink) return null

  return (
    <MenuItem
      icon={isZipFileDownloading ? <LoadingIcon /> : <CProductImages />}
      isDisabled={isZipFileDownloading}
      onClick={onClickDownloadZip}
      aria-label="Download zip with article images"
    >
      <Text fontWeight="medium">{t("pdp-article-more-pic")}</Text>
    </MenuItem>
  )
}

export default DownloadImagesMenuItem

DownloadImagesMenuItem.propTypes = {
  zipPhotosDrawingsLink: PropTypes.string,
}
